<template>
  <div></div>
</template>

<script>
import {
  apiPaypayserve,
} from "@/request/API";
export default {
  name: 'blank',
  data() {
    return {
      gameid: this.$route.query.gameid,
      id: this.$route.query.id,
      orderid: this.$route.query.orderid,
      uniqueno: this.$route.query.uniqueno
    }
  },
  created() {
    apiPaypayserve({
      id: this.orderid,
      return_url:`${process.env.VUE_APP_WEBSITE}/sinceritypayment?orderid=${this.orderid}&id=${this.id}&gameid=${this.gameid}&uniqueno=${this.unique_no}`
    }).then(response=>{
      const div = document.createElement("divform");
      div.innerHTML = response.data.from_data
      document.body.appendChild(div);
      document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
      document.forms[0].submit();
      div.remove();
    })
  },
}
</script>

<style>

</style>